export const phrasesLocalStorageKey = 'ft-phrases-v1.0';
